import { useCallback, useEffect, useState } from "react";
import Attribute from "./Attribute";
import "./styles.scss";
import { parseAttributeValue } from "./utils";

const EMPTY_DEFAULT_VALUES = {};

function AttributesPicker({
  availableAttributes,
  publicTest,
  onChangeHandler,
  isSpecialAttributes = false,
  defaultValues = EMPTY_DEFAULT_VALUES,
}) {
  const [currentAttributes, setCurrentAttributes] = useState({});
  const [hiddenAttributes, setHiddenAttributes] = useState({});
  const updateAttributes = useCallback(
    attributes => {
      setCurrentAttributes(attributes);
      onChangeHandler(attributes);
    },
    [onChangeHandler]
  );

  useEffect(() => {
    const preselectedAttrs = availableAttributes.reduce((acc, attr) => {
      const values = publicTest[`${attr}Value`];
      if (values.length === 1) {
        acc[attr] = parseAttributeValue(values[0]).value;
      }

      return acc;
    }, {});

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHiddenAttributes(preselectedAttrs);
    // preselectedAttrs (single-value locked attrs) takes priority over URL defaults
    updateAttributes({ ...defaultValues, ...preselectedAttrs });
  }, [publicTest, availableAttributes, defaultValues, updateAttributes]);

  const onChange = attributes => {
    updateAttributes({ ...currentAttributes, ...attributes });
  };

  return (
    <div className="tg_attributes-picker">
      {availableAttributes.map((attr, i) => {
        return (
          <Attribute
            key={attr}
            index={i + 1}
            attribute={attr}
            onChange={onChange}
            publicTest={publicTest}
            currentAttributes={currentAttributes}
            isSpecialAttributes={isSpecialAttributes}
            isHidden={!!hiddenAttributes[attr]}
            isPreset={!!defaultValues[attr] && !hiddenAttributes[attr]}
          />
        );
      })}
    </div>
  );
}

export default AttributesPicker;
